module.exports = __webpack_public_path__ + "static/media/cruise-deal.4639a510.webp";